<!-- 预约导师 -->
<template>
  <div class="application-mentor">
    <zlr-progress :percent="percent"
                  :stick=true
                  :typeColor=1></zlr-progress>
    <div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="application-mentor-title">
            0. 选择视频工具
          </div>
          <!-- v-if="isTencentVideoShow" -->
          <div class="application-mentor-tools">
            <span @click="vidoeHandle('TENCENT')"
                  :class="{'active-bg': formData.videoType === 'TENCENT'}"
                  >MSP内置视频聊天（试用）</span>
            <!-- <span @click="vidoeHandle('ZOOM')"
                  :class="{'active-bg': formData.videoType === 'ZOOM'}">Zoom视频会议（原有）</span> -->
          </div>
          <!-- 环境检测https://www.qcloudtrtc.com/webrtc-samples/abilitytest/index.html -->
          <div class="tencent-note"
               v-if="isTencentVideoShow">
            Note: 试用内置视频聊天, 请先<a target="_blank"
               href="https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html">跳转检测</a>使用环境；如有相关问题，欢迎通过“问题反馈”反馈</div>
        </div>
      </div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="dis-40">
            <div class="application-mentor-title">
              1. 您所在时区
            </div>
            <div class="application-mentor-zone">
              <!-- 有值加class  active-select -->
              <div :class="{'active':formData.menteeZone}">
                <Select placeholder="Select"
                        v-model="formData.menteeZone">
                  <Option :value="item.value"
                          v-for="(item,index) in zoneMap"
                          :key="index">{{item.title}}</Option>
                </Select>
              </div>
            </div>
            <div :class="{'application-mentor-cover': !formData.videoType }"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              2. 您期望辅导时间 - 优先
            </div>
            <div class="application-mentor-coach">
              <div class="application-mentor-coach-list"
                   :class="{'active': formData.timeContent[0][0],'active-error':compareTime[0]}">
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            v-model="formData.timeContent[0][0]"
                            @on-change="firstDateHandle"></DatePicker>
              </div>
              <div class="application-mentor-coach-list"
                   :class="{'active': formData.timeContent[0][1]&&formData.timeContent[0][1][0],'active-error':compareTime[0]}">
                <TimePicker type="timerange"
                            placeholder="Select time"
                            format="HH:mm"
                            :steps="[1, 10]"
                            @on-change="firstTimeHandle"
                            v-model="formData.timeContent[0][1]"
                            style="width:100%;"></TimePicker>
              </div>
            </div>
            <div class="application-mentor-coach-prompt"
                 v-if="compareTime[0]">
              建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
            </div>
            <div :class="{'application-mentor-cover':!formData.menteeZone}"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              3. 您期望辅导时间 - 次要
            </div>
            <div class="application-mentor-coach">
              <div class="application-mentor-coach-list"
                   :class="{'active': formData.timeContent[1][0],'active-error':compareTime[1]}">
                <DatePicker type="date"
                            placeholder="Select date"
                            @on-change="secondDateHandle"
                            v-model="formData.timeContent[1][0]"
                            style="width:100%;">
                </DatePicker>
              </div>
              <div class="application-mentor-coach-list"
                   :class="{'active': formData.timeContent[1][1]&&formData.timeContent[1][1][0],'active-error':compareTime[1]}">
                <TimePicker type="timerange"
                            placeholder="Select time"
                            format="HH:mm"
                            :steps="[1, 10]"
                            style="width:100%;"
                            @on-change="secondTimeHandle"
                            v-model="formData.timeContent[1][1]"></TimePicker>
              </div>
            </div>
            <div class="application-mentor-coach-prompt"
                 v-if="compareTime[1]">
              建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
            </div>
            <div :class="{'application-mentor-cover':!formData.timeContent[0][0]||!formData.timeContent[0][1]||!formData.timeContent[0][1][0]}"></div>
          </div>
          <div v-if="isAddTimeContent">
            <div class="dis-40">
              <div class="application-mentor-title">
                4. 您期望辅导时间 - 次要
              </div>
              <div class="application-mentor-coach">
                <div class="application-mentor-coach-list"
                    :class="{'active': formData.timeContent[2][0],'active-error':compareTime[2]}">
                  <DatePicker type="date"
                              placeholder="Select date"
                              v-model="formData.timeContent[2][0]"
                              @on-change="threeDateHandle"
                              style="width:100%;"></DatePicker>
                </div>
                <div class="application-mentor-coach-list"
                    :class="{'active': formData.timeContent[2][1]&&formData.timeContent[2][1][0],'active-error':compareTime[2]}">
                  <TimePicker type="timerange"
                              placeholder="Select time"
                              format="HH:mm"
                              :steps="[1, 10]"
                              @on-change="threeTimeHandle"
                              v-model="formData.timeContent[2][1]"
                              style="width:100%;"></TimePicker>
                </div>
              </div>
              <div class="application-mentor-coach-prompt"
                  v-if="compareTime[2]">
                建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
              </div>
              <div :class="{'application-mentor-cover':!formData.timeContent[1][0]||!formData.timeContent[1][1]||!formData.timeContent[1][1][0]}"></div>
            </div>
          </div>
          <div class="dis-0">
            <div><Button @click="chanbgeAddTimeContent">{{!isAddTimeContent?'添加次要辅导时间':'删除次要辅导时间'}}</Button></div>
            <div :class="{'application-mentor-cover':!formData.timeContent[1][0]||!(formData.timeContent[1][1]&&formData.timeContent[1][1][0])}"></div>
          </div>
        </div>
      </div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="dis-0"
               :class="{'zlr-cover':!formData.timeContent[2][0]||!formData.timeContent[2][1]||!formData.timeContent[2][1][0]}" v-if="isAddTimeContent">
            <div class="application-mentor-title">
              其它您想告知导师的信息（请用英文填写）
            </div>
            <div>
              <editor ref="analysisEditor"
                      :cache=false
                      v-model.trim="formData.description" />
            </div>
            <div class="application-mentor-btn">
              <Button class="application-mentor-btn-back"
                      @click="backHandle">返回</Button>
              <div style="display: inline-block;">
                <Button class="application-mentor-btn-sub"
                        type="primary"
                        @click="subHandle"
                        :loading="isSub">发起预约</Button>
              </div>
            </div>
          </div>
          <div class="dis-0"
               :class="{'zlr-cover':!formData.timeContent[1][0]||!formData.timeContent[1][1]||!formData.timeContent[1][1][0]}" v-if="!isAddTimeContent">
            <div class="application-mentor-title">
              其它您想告知导师的信息（请用英文填写）
            </div>
            <div>
              <editor ref="analysisEditor"
                      :cache=false
                      v-model.trim="formData.description" />
            </div>
            <div class="application-mentor-btn">
              <Button class="application-mentor-btn-back"
                      @click="backHandle">返回</Button>
              <div style="display: inline-block;">
                <Button class="application-mentor-btn-sub"
                        type="primary"
                        @click="subHandle"
                        :loading="isSub">发起预约</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getAppCreate, getAppTimeConvert } from '@/api/appointment'
import { getJointDetail } from '@/api/joint'
import { getTencentVideoShow } from '@/api/info'
// components
import ZlrProgress from '_c/progress/progress'
import Editor from '_c/editor/editor'
// constant
import { zoneMap } from '@/constant'
import dayjs from 'dayjs'
import { mapState } from 'vuex'
export default {
  name: 'project-interview-mentor',
  components: {
    ZlrProgress,
    Editor
  },
  data () {
    return {
      percent: 0,
      zoneMap,
      programId: this.$route.params.id,
      formData: {
        timeContent: [[], [], []]
      },
      isSub: false,
      mentorDetail: {},
      compareTime: [],
      // 腾讯视频是否展示
      isTencentVideoShow: false,
      isAddTimeContent: false
    }
  },
  computed: {
    ...mapState({
      projectDetail (state) {
        return state.project.projectDetail
      }
    })
  },
  mounted () {
    this.getJointDetail()
    this.getTencentVideoShow()
  },
  methods: {
    // 获取腾讯视频是否展示
    getTencentVideoShow () {
      getTencentVideoShow().then(res => {
        this.isTencentVideoShow = res.data.model
      })
    },
    // 获取导师详情
    getJointDetail () {
      if (!this.projectDetail.jointId) return false
      getJointDetail({
        id: this.projectDetail.jointId
      }).then(res => {
        this.mentorDetail = res.data.model
      })
    },
    subHandle () {
      let data = JSON.parse(JSON.stringify(this.formData))
      data.content = []
      data.timeContent.forEach(item => {
        if (item.length > 0) {
          let date = dayjs(item[0]).format('YYYY-MM-DD')
          data.content.push({
            maxTimeStr: `${date} ${item[1][1]}`,
            minTimeStr: `${date} ${item[1][0]}`
          })
        }
      })
      this.isSub = true
      delete data.timeContent
      data.projectId = this.programId
      data.jointId = this.projectDetail.jointId
      data.type = 'INTERVIEW'
      getAppCreate(data).then(res => {
        this.$zlr_message('发起预约成功，待导师确认', 'success')
        this.backHandle()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    // 选择视频
    vidoeHandle (value) {
      this.$set(this.formData, 'videoType', value)
      this.zoneChange('')
    },
    // 选择时区
    zoneChange (value) {
      this.$set(this.formData, 'menteeZone', value)
      this.clearTimeHandle(0)
      this.firstDateHandle()
    },
    // 首选 - 选择日期
    firstDateHandle () {
      this.clearTimeHandle(1)
      this.secondDateHandle(2)
      this.timeCompare(0)
    },
    // 首选 - 选择时间
    firstTimeHandle () {
      this.clearTimeHandle(1)
      this.secondDateHandle(2)
      this.timeCompare(0)
    },
    // 次选 - 选择日期
    secondDateHandle () {
      this.clearTimeHandle(2)
      this.threeDateHandle()
      this.timeCompare(1)
    },
    // 次选 - 选择时间
    secondTimeHandle () {
      this.clearTimeHandle(2)
      this.threeDateHandle()
      this.timeCompare(1)
    },
    // 次选 - 选择日期
    threeDateHandle () {
      this.$set(this.formData, 'description', '')
      this.timeCompare(2)
    },
    // 次选 - 时间
    threeTimeHandle () {
      this.timeCompare(2)
    },
    // 进续转换时间比较
    timeCompare (index) {
      let time = this.formData.timeContent[index]
      this.$set(this.compareTime, index, false)
      if (!time[0] || !time[1] || !time[1][1] || !time[1][1][0]) {
        return false
      }
      let date = dayjs(time[0]).format('YYYY-MM-DD')
      let timeQuantum = {
        minTimeStr: `${date} ${time[1][0]}`,
        maxTimeStr: `${date} ${time[1][1]}`
      }
      getAppTimeConvert({
        menteeZone: this.formData.menteeZone,
        mentorZone: this.mentorDetail.mentorInfo.mentorZone,
        timeQuantum
      }).then(res => {
        let { minTimeStr, maxTimeStr } = res.data.model
        let minHour = dayjs(minTimeStr).hour()
        let maxHour = dayjs(maxTimeStr).hour()
        if ((minHour > 0 && minHour < 6) || (maxHour > 0 && maxHour < 6)) {
          this.$set(this.compareTime, index, true)
        }
      })
    },
    clearTimeHandle (index) {
      this.$set(this.formData.timeContent, index, [])
    },
    // 返回上一页
    backHandle () {
      this.$router.go(-1)
    },
    // 添加辅导时间时间段
    chanbgeAddTimeContent () {
      this.isAddTimeContent = !this.isAddTimeContent
      if (!this.isAddTimeContent) {
        this.secondTimeHandle()
      }
    }
  },
  watch: {
    formData: {
      handler (data) {
        let index = 0
        if (data.description) {
          index = 6
        } else if (data.timeContent[2][0] && data.timeContent[2][1]) {
          index = 5
        } else if (data.timeContent[1][0] && data.timeContent[1][1]) {
          index = 4
        } else if (data.timeContent[0][0] && data.timeContent[0][1]) {
          index = 3
        } else if (data.menteeZone) {
          index = 2
        } else if (data.videoType) {
          index = 1
        } else {
          index = 0
        }
        this.percent = (index / 6) * 100
      },
      deep: true
    },
    projectDetail () {
      this.getJointDetail()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
